import Magic from "./Magic";
const magicKey = "pk_live_9966048C5F75485A";
const magic = new Magic(magicKey); // ✨
export default magic;
